import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * Checkmark Icon Component
 * Filled circle with checkmark (solid style)
 * Used for confirmed/selected states
 */
class CheckmarkIcon extends BaseIcon {
    constructor() {
        super();
        this.size = 5; // Default: h-5 w-5 (20px) to match original usage
    }

    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 20 20',
            fill: 'currentColor',
        };
    }

    renderIconPath() {
        return svg`
            <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
            />
        `;
    }
}

customElements.define('checkmark-icon', CheckmarkIcon);
